var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-top",on:{"click":_vm.scrollToTop}},[_vm._v("UP")])}
var staticRenderFns = []

export { render, staticRenderFns }